import styled from 'styled-components'
import { Link } from 'gatsby'

export const StyledButton = styled.button`
	font-size: 16px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: normal;
	color: #ffffff;
	text-transform: capitalize;
	border: none;
	background: none;
	outline: none;
	cursor: pointer;
	text-decoration: none;
	transition: 0.3s;
	padding: 12px 0;
	:hover {
		color: #89c35c;
	}
	${({ headerBackground }) =>
		headerBackground &&
		`
  color: ${headerBackground ? '#264445' : '#ffffff'};
  
  `};

	${({ darkColor }) =>
		darkColor &&
		`
      
  color: #37373A
  
  `}
`

export const StyledMainContainer = styled.div`
	position: relative;
`

export const StyledDropDownContent = styled.div`
	display: ${p => (p.show ? 'grid' : 'none')};
	position: absolute;
	min-width: 160px;
	z-index: 12;
	align-items: center;
	padding: 30px 20px 39px 27px;
	right: -150px;
	width: 376px;
	box-sizing: border-box;
	grid-row-gap: 23px;
	background: #ffffff;
	box-shadow: 0 10px 34px rgba(191, 196, 202, 0.5);
	border-radius: 4px;
`
export const StyledDropDownContentDefault = styled(StyledDropDownContent)`
	padding: 30px 42px 37px 32px;
	width: 220px;
	right: -100px;
`

export const StyledDropDownBtn = styled.button``

export const StyledIcon = styled.img`
	width: 20px;
	height: 18px;
	margin-right: 10px;
`

export const StyledLink = styled(Link)`
	text-decoration: none;
	padding: 5px 0;
	color: #264445;
	display: grid;
	grid-column-gap: 5px;
	grid-template-columns: 30px 1fr;
	transition: all 0.5s ease;
	align-items: center;
	span {
		font-family: 'tbc-Medium', sans-serif;
		font-style: normal;
		font-weight: normal;
		font-size: 16px;
		line-height: 16px;
		color: #000000;
	}
	:hover {
		color: #89c35c;
		p:first-child {
			color: #89c35c;
		}
	}
`

export const StyledTitleLink = styled.p`
	text-decoration: none;
	padding: 5px 0;
	color: #264445;
	transition: all 0.5s ease;
	:hover {
		color: #89c35c;
		p:first-child {
			color: #89c35c;
		}
	}
`

export const StyledDescription = styled.p`
	font-size: 14px;
	color: #bdbdbd;
`
export const StyledTitle = styled.p`
	font-size: 14px;
	color: #264445;
`
export const StyledInnerContainer = styled.div`
	display: grid;
	grid-row-gap: 4px;
`
